var React = require('react');

function ShieldAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M496 128c0 221.29-135.9 344.6-221.6 380.32A48.29 48.29 0 0 1 256 512V0a48.18 48.18 0 0 1 18.5 3.67l192 80A48 48 0 0 1 496 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 0v512a48.18 48.18 0 0 1-18.5-3.67C130.5 463.72 16 326.52 16 128a48 48 0 0 1 29.6-44.32l192-80A48.29 48.29 0 0 1 256 0z","className":"fa-primary","key":2})]);
}

ShieldAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ShieldAlt;

ShieldAlt.default = ShieldAlt;
